"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refineConditionalFields = exports.AssetConditionalFieldMap = void 0;
const realEstateAsset_1 = require("../realEstateAsset");
const assetData_1 = require("../../asset/assetData");
const lodash_1 = require("lodash");
const zod_1 = require("zod");
const getTypeOfSchema_1 = require("../../getTypeOfSchema");
const renderingConditions_1 = require("../../asset/renderingConditions");
const investmentData_1 = require("../../asset/investmentData");
exports.AssetConditionalFieldMap = (0, renderingConditions_1.combineConditionalFieldMap)(investmentData_1.AssetInvestmentDataRenderingConditions, assetData_1.AssetDataRenderingConditions);
/**
 * Refinement to check whether fields exist, that are dependent on other fields.
 */
const refineConditionalFields = (val, ctx) => {
    for (const assetPath in exports.AssetConditionalFieldMap) {
        const shouldExistFunc = assetData_1.AssetDataRenderingConditions[assetPath];
        if (!shouldExistFunc) {
            continue;
        }
        const shouldExist = shouldExistFunc(val);
        if (!shouldExist) {
            continue;
        }
        if (shouldExist && !(0, lodash_1.get)(val, assetPath)) {
            ctx.addIssue({
                path: assetPath.split('.'),
                code: zod_1.z.ZodIssueCode.invalid_type,
                expected: (0, getTypeOfSchema_1.getTypeOfField)(realEstateAsset_1.ApprovableRealEstateAsset, assetPath),
                received: 'null',
            });
        }
    }
    if (val.investorSettings?.calculateReturnOnEquity && !val.documents?.scenarioCalculations) {
        ctx.addIssue({
            code: 'custom',
            message: 'Scenario calculations is required if calculate return on equity is set to true',
        });
    }
};
exports.refineConditionalFields = refineConditionalFields;
//# sourceMappingURL=conditional-field-map.js.map